<template>
    <div id="oneKeeper-login" class="oneKeeper-login">
        <header>
            <div class="logo">
                <img src="/img/login-logo.svg" alt="logo">
            </div>
        </header>
        <div class="content">
            <div class="left"></div>
            <div class="right">
                <div class="login-board">
                    <div class="login-board-title">
                        <p>超级用户登陆</p>
                    </div>
                    <mc-layout-row label-icon-left="iconfont okp-fonts-user" :labelWidth="70">
                        <el-input type="text" placeholder="账号" v-model="username" clearable></el-input>
                    </mc-layout-row>
                    <mc-layout-row label-icon-left="iconfont okp-3701mima" :labelWidth="70">
                        <el-input type="password" placeholder="密码" v-model="password" clearable></el-input>
                    </mc-layout-row>
                    <el-button type="primary" class="login-board-submit" @click="$_login_superviser">登录</el-button>
                    <p class="login-board-user-type">
                    </p>
                </div>
            </div>
        </div>
        <footer v-if="!!footer">
          {{ footer.copyright }} {{ footer.project }} | 
          <a target="_blank" :href="footer.icp.link" style="margin-left:5px;">{{footer.icp.text}}</a>
        </footer>
    </div>
</template>

<script>
    const log = new Log("Page/oneKeeper-login");
    export default {
        name: "oneKeeper-login",
        data() {
            return {
                username: "",
                password: "",
                footer: "",
            }
        },
        methods: {
            $_getFooter() {
                axios.get("/config/footer.json").then(res => {
                    this.footer = res.data;
                });
            },
            $_login_superviser: async function () {
                // let params = {
                //     login_username: "huxh@mchz.com.cn",
                //     login_password: "123456"
                // }
                let params = {
                    login_username: this.username,
                    login_password: this.password
                }
                let data = await this.$api.admin.oneKeeperLogin.call(this, params);
                if (data !== false) {
                    axios.defaults.headers.common = {
                        Authorization: "Onekeeper " + data.access_token,
                    };
                    window.sessionStorage.token = data.access_token;
                    window.sessionStorage.refreshToken = data.refresh_token;
                    window.sessionStorage.username = data.name ? data.name : "Super Admin";
                    window.sessionStorage.id = data.id;
                    window.sessionStorage.userType = "oneKeeper";
                    this.$router.push({
                        name: "surperAdmin"
                    });
                }
            },
        },
        created() {
            // this.$_getFooter();
            // window.sessionStorage.clear();
            //  this.$store.state.view.type = 'oneKeeper';
        },
    }
</script>

<style lang="less" scoped>
    @Height_Header: 70px;
    @Height_Footer: 60px;

    .oneKeeper-login {
        width: 100%;
        height: ~ "calc(100vh)";
        overflow: hidden;
        background-image: url("/img/login-bg.png");
        background-size: cover;

        header {
            width: 100%;
            height: @Height_Header;
            padding: 0 15px;
            background-color: #fff;

            .logo {
                width: 100%;
                height: 100%;
                padding: 0 15px;
                display: flex;
                align-items: center;

                img {
                    width: 290px;
                    height: 40px;
                }
            }
        }

        .content {
            width: 100%;
            height:~"calc(100vh - @{Height_Header} - @{Height_Footer})";
            display: flex;

            .left {
                width: 60%;
                height: 100%;
            }

            .right {
                width: 40%;
                height: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .login-board {
                    width: 390px;
                    padding: 40px;
                    min-height: 300px;
                    background-color: #fff;
                    border-radius: 5px;

                    .login-board-title {
                        width: 100%;
                        height: 60px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        p {
                            font-size: 14px;
                            margin: 0;
                            padding: 0;
                            font-weight: 600;
                        }
                    }

                    .login-board-submit {
                        width: 100%;
                        margin-top: 45px;
                        margin-bottom: 10px;
                    }

                    .login-board-user-type {
                        width: 100%;
                        margin: 10px 0;

                        label {
                            cursor: pointer;
                            color: #409EFF;

                            &:hover {
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }
        }

        footer {
            width: 100%;
            height: @Height_Footer;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;

            a {
                text-decoration: none;
                color: #337ab7;
            }
        }
    }
</style>
